/* eslint-disable camelcase */
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { trackWindowScroll } from 'react-lazy-load-image-component';
import cn from 'classnames';
import { useReactiveVar } from '@apollo/client';

import { analyticService } from 'global/services';

import { ADDITIONAL_DISHES_CATEGORIES } from 'app/const/categories';
import { MenuDispatchContext } from 'app/containers/contexts/menu.context';
import { selectedPeriodVar } from 'app/apollo/reaction';

import Responsive from 'app/components/Responsive';
import DishDAC from 'app/views/Menu/Menu/DAC/DishDAC';

import {
    abTestDataContext,
} from 'app/containers/contexts/abTest.context';
import { PromoMaxiBlock, isPromoBlockActive } from 'app/components/PromoMaxiBlock/PromoMaxiBlock';

import '../../../../../../components/Dishes/dishes.scss';
import { useMenuSelectionsDishes } from 'app/components/BR1258/hooks/useMenuSelectionsDishes';
import { SpecialBanners } from 'app/components/SpecialBanners/SpecialBanners';
import { getMaxiBlockDishes } from 'app/components/BR1258/utils/getMaxiBlocksDishes';

const isShelfLifeDisplayed = (categoryId) => ADDITIONAL_DISHES_CATEGORIES.includes(categoryId);

const PROMO_SELECTION_KEYS = ['harry', 'kids', 'sauces'];

const isLazyLoadingEnabled = (isCategoryActive, index, useLazyLoading) => {
    if (!isCategoryActive) {
        return useLazyLoading;
    }

    if (index === 0) {
        return false;
    }

    return useLazyLoading;
};

class DishesV2 extends React.Component {
    constructor(props) {
        super(props);
        this.listRef = React.createRef();
    }

    // eslint-disable-next-line react/sort-comp, class-methods-use-this, consistent-return
    trackDishDetailsViewed = (dishId) => {
        const {
            categoryTitle,
            menuDishesQuery: { menuDishes },
            categoryId,
            subscriptionType,
        } = this.props;

        const dish = menuDishes.find(({ id }) => Number(id) === Number(dishId));

        if (!dish) return null;

        const {
            id,
            title,
            caption,
            price,
        } = dish;

        analyticService.push({
            id,
            title,
            caption,
            price,
            category: categoryTitle,
            categoryId,
            source: 'menu',
            eventName: 'Dish_Details_Viewed',
            subscriptionType,
        }).push({
            id,
            eventName: 'CityAds_Dish_Details_Viewed',
        });
    };

    dispatchOnCardClickAnalytic = (dish) => {
        const { subscriptionType } = this.props;
        analyticService.push({
            eventName: 'Track_Card_Click', ...dish, list: 'all', subscriptionType,
        });
    };

    render() {
        const {
            spaDishObserver,
            isCategoryActive,
            menuDishesQuery,
            useLazyLoading,
            isBasketLoading,
            isDishesUpdating,
            categoryId,
            isDishesSliderNeeded,
            dishComponentType,
            updateLastDish,
            thirdDishId,
            fifthDishId,
            sixthDishId,
            seventhDishId,
            tenthDishId,
            thirteenthDishId,
            selectionPositions,
            dishesToFilter,
            selectedPeriod,
            ...dishesProps
        } = this.props;

        const { menuDishes } = menuDishesQuery;

        const isSelectionDish = categoryId === 'selection' && dishComponentType === 'mobile';

        const dishesListRoot = cn({
            'dishes-list': true,
            [categoryId]: true,
        });

        const filteredDishes = menuDishes.filter((d) => !dishesToFilter.includes(d.id));

        const activePromoKeys = PROMO_SELECTION_KEYS.filter(
            (key) => isPromoBlockActive(key, selectedPeriod),
        );

        return (
            <ul styleName={dishesListRoot} ref={this.listRef}>
                {filteredDishes.map((dish, i, arr) => {
                    const arrTail = arr.length - 1;
                    const useLazyLoadingProp = isLazyLoadingEnabled(isCategoryActive, i, useLazyLoading);

                    if (dish.id === '4847') {
                        return null;
                    }

                    const commonProps = {
                        arrTail,
                        index: i,
                        isShelfLife: isShelfLifeDisplayed(categoryId),
                        parentRef: this.listRef,
                        useLazyLoading: useLazyLoadingProp,
                        canApplySoldOutStyles: true,
                        onOpenDetails: this.trackDishDetailsViewed,
                        dispatchOnCardClickAnalytic: this.dispatchOnCardClickAnalytic,
                        spaDishObserver,
                        ...dishesProps,
                        categoryId,
                    };

                    const num_cID = categoryId === 'intresting' ? '0' : String(categoryId);

                    const cID = categoryId === 'intresting' ? `${dish.id}:0` : `${dish.id}:${categoryId}`;

                    const sliderContainerClasses = cn({
                        'dishes-list__slider-container': true,
                        'is-hidden': isDishesUpdating,
                    });

                    const onClick = (data) => {
                        const { onClickAddToBasket } = dishesProps;
                        const { updatePromoCompoentPosition } = this.props;
                        onClickAddToBasket(data);
                        updatePromoCompoentPosition(data.rootDishID, num_cID);
                    };

                    return (
                        <React.Fragment key={dish.id}>
                            <Responsive
                                mobile={(
                                    <>
                                        <DishDAC
                                            id={dish.id}
                                            cardProps={{
                                                ...commonProps,
                                                disabled: isBasketLoading,
                                                isDishUpdating: isDishesUpdating,
                                                onClickAddToBasket: onClick,
                                                isLastDish: i === arrTail,
                                            }}
                                            cardLayout="mobile"
                                        />
                                        {(cID === thirdDishId) && (
                                            <div
                                                key={`special-${cID}`}
                                                id="specialsThird"
                                                style={{ width: '100%' }}
                                            >
                                                <SpecialBanners
                                                    ids="green.kids.guests"
                                                    specialsAncor="specialsThird"
                                                    isV2
                                                />
                                            </div>
                                        )}
                                        {selectionPositions.map((position, selectionIndex) => {
                                            if (cID !== position) {
                                                return null;
                                            }

                                            const promoSelectionKey = activePromoKeys[selectionIndex];

                                            if (!promoSelectionKey) {
                                                return null;
                                            }

                                            return (
                                                <div
                                                    key={`selection-${position}`}
                                                    styleName={`${i === arrTail ? 'afterLast' : 'inBetween'}`}
                                                >
                                                    <PromoMaxiBlock
                                                        contentKey={promoSelectionKey}
                                                        selectionKey={promoSelectionKey}
                                                        observer={spaDishObserver}
                                                    />
                                                </div>
                                            );
                                        })}
                                        {/* {(cID === thirdDishId) && (
                                            <div style={{ width: '100%' }}>
                                                <div styleName={sliderContainerClasses}>
                                                    <MenuSelectionsMobileSlider realm="menu_realm" />
                                                </div>
                                            </div>
                                        )} */}
                                    </>
                                )}
                                desktop={(
                                    <DishDAC
                                        id={dish.id}
                                        cardProps={dishComponentType === 'mobile'
                                            ? {
                                                disabled: isBasketLoading,
                                                isDishUpdating: isDishesUpdating,
                                                ...commonProps,
                                            }
                                            : commonProps}
                                        cardLayout={isSelectionDish ? 'mobile' : 'desktop'}
                                    />
                                )}
                                key={dish.id}
                            />
                        </React.Fragment>
                    );
                })}
            </ul>
        );
    }
}

DishesV2.propTypes = {
    isCategoryActive: PropTypes.bool,
    overlayIsOpen: PropTypes.bool,

    isDishesUpdating: PropTypes.bool.isRequired,
    useLazyLoading: PropTypes.bool,
    menuDispatchContext: PropTypes.func.isRequired,
    categoryTitle: PropTypes.string,
    isDishesSliderNeeded: PropTypes.bool.isRequired,

    spaDishObserver: PropTypes.shape({
        observe: PropTypes.func,
    }).isRequired,

    menuDishesQuery: PropTypes.shape({
        loading: PropTypes.bool,
        error: PropTypes.shape({}),
        menuDishes: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
    categoryId: PropTypes.string.isRequired,
    isMobileMenuDishesVisible: PropTypes.bool.isRequired,
    selectedPeriod: PropTypes.string,

    dishComponentType: PropTypes.string,
    subscriptionType: PropTypes.string,
};

const MenuSliderAdapter = ({
    isCategoryActive = false,
    overlayIsOpen = false,
    useLazyLoading = true,
    categoryTitle = '',
    dishComponentType = 'responsive',
    subscriptionType = '',
    menuDishesQuery,
    menuDishesQuery: { menuDishes },
    isDishesSliderNeeded,
    isDishesUpdating,
    location,
    spaDishObserver,
    ...restProps
}) => {
    const menuDispatchContext = useContext(MenuDispatchContext);
    const abTestDataContextValue = useContext(abTestDataContext);
    const selectedPeriod = useReactiveVar(selectedPeriodVar);

    const { allDishes } = useMenuSelectionsDishes();
    const maxiBlockDishes = getMaxiBlockDishes();

    const hiddenDishes = useMemo(
        () => [...allDishes, ...maxiBlockDishes],
        [allDishes, maxiBlockDishes],
    );

    const dishesToFilter = useMemo(
        () => hiddenDishes.map((d) => d.id),
        [hiddenDishes],
    );

    return (
        <DishesV2
            {...restProps}
            abTestDataContext={abTestDataContextValue}
            menuDispatchContext={menuDispatchContext}
            menuDishesQuery={menuDishesQuery}
            isDishesUpdating={isDishesUpdating}
            subscriptionType={subscriptionType}
            isDishesSliderNeeded={isDishesSliderNeeded}
            spaDishObserver={spaDishObserver}
            isCategoryActive={isCategoryActive}
            overlayIsOpen={overlayIsOpen}
            useLazyLoading={useLazyLoading}
            categoryTitle={categoryTitle}
            dishComponentType={dishComponentType}
            dishesToFilter={dishesToFilter}
            selectedPeriod={selectedPeriod}
        />
    );
};

MenuSliderAdapter.propTypes = {
    categoryId: PropTypes.string.isRequired,
    menuDishesQuery: PropTypes.shape({
        menuDishes: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
    isDishesSliderNeeded: PropTypes.bool.isRequired,
    isDishesUpdating: PropTypes.bool.isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
        search: PropTypes.string.isRequired,
    }).isRequired,
    subscriptionType: PropTypes.string,
};

export default trackWindowScroll(MenuSliderAdapter);

